import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'
import { useQuery } from 'react-query'

const useJobLogs = ({
    jobId,
    limit,
    offset = 0,
}) => {
    const cacheKeys = useCacheKeys()
    const { api, endpoints, url, time } = useApi()

    const { data, isLoading, isFetching } = useQuery(
        [cacheKeys.JOBS, jobId],
        () => api.get(url(endpoints.jobLogs, { jobId }, { offset, limit })),
        {
            staleTime: time.HOUR,
        }
    )

    return {
        isLoading: isLoading || isFetching,
        jobLogs: data ? data.items : [],
    }
}

export default useJobLogs